// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "js/vendors.231a6554.js";
	// return url for filenames based on template
	return "js/" + ({"239":"vendor-antd","310":"vendor-copilot","967":"vendor-react"}[chunkId] || chunkId) + "." + {"69":"7a7fecfe","137":"2874979e","192":"da63b80c","239":"06aaee88","310":"5e46d8b0","314":"ce992761","331":"3475cab1","444":"5e4ca286","857":"1e44dfb7","967":"0b181b8c"}[chunkId] + ".chunk.js";
};